/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React, { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { Copy } from "@jda/lui-common-icon-library-mui5";
import { LuiObjectStatus, Alert } from "@jda/lui-common-component-library-mui5";
import { Box, Tooltip, Typography, Grid } from "@mui/material";

import { useStyles } from "./styles";

interface IDisplayContentProps {
  contentText: string;
  content: string;
  testId: string;
  handleCopyClick?: Function;
  status?: string;
}

const STATUS = {
  PENDING: Alert.INFORMATION,
  PROVISIONING: Alert.INFORMATION,
  PROVISIONING_FAILED: Alert.ERROR,
  ACTIVE: Alert.SUCCESS,
  INACTIVE: Alert.DEFAULT,
  DELETED: Alert.DEFAULT,
  MARKED_FOR_DELETION: Alert.DEFAULT,
  BEING_DELETED: Alert.DEFAULT,
};

const DisplayContent: React.FC<IDisplayContentProps> = ({
  contentText,
  content,
  testId,
  handleCopyClick,
  status = "",
}) => {
  const classes = useStyles();
  const [, setCopied] = useState(false);
  const handleClick = () => {
    setCopied(true);
    if (handleCopyClick) {
      handleCopyClick();
    }
  };
  return (
    <Box className={classes.realmDetailsInputContent}>
      <Grid item xs={3}>
        <Typography
          data-testid={`${testId}-label`}
          gutterBottom
          variant="body2"
          color="textSecondary"
        >
          {contentText}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <Box className={classes.valueContainer}>
          {status ? (
            <Box>
              <LuiObjectStatus
                title={content}
                size="medium"
                type="secondary"
                state={STATUS[status] || Alert.DEFAULT}
              />
            </Box>
          ) : (
            <Typography
              data-testid={`${testId}-value`}
              gutterBottom
              variant="body1"
              className={classes.content}
            >
              {content}
            </Typography>
          )}
          {handleCopyClick && content !== "N/A" && (
            <Tooltip title="copy">
              <Box data-testid="toolTip-sign">
                <CopyToClipboard text={content} onCopy={handleClick}>
                  <Copy className={`${classes.pointer}`} fontSize="small" />
                </CopyToClipboard>
              </Box>
            </Tooltip>
          )}
        </Box>
      </Grid>
    </Box>
  );
};

export default DisplayContent;
